import { Autocomplete, TextField, useMediaQuery } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useTheme } from "@emotion/react";

const SelectDepositAccount = ({ onSelect, ...props }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { authToken, ezorder } = useContext(AuthContext);
  const [depositAccounts, setDepositAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  const getDepositAccounts = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(`/quickbooks/accounts`, data);

      setDepositAccounts(response.data.accounts);
    } catch (error) {
      console.log("Failed To Load Payment Methods");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getDepositAccounts();
  }, []);

  return (
    <>
      <Autocomplete
        loading={loading}
        fullWidth={isSmallScreen}
        // disablePortal
        onChange={(Event, newValue, reason, details) => {
          //   if (reason == "selectOption") setValue(newValue);
          onSelect(newValue);
        }}
        getOptionLabel={(option) => option.Name}
        options={depositAccounts}
        isOptionEqualToValue={(option, value) => {
          if (!value) return false;
          return option.Id === value.Id;
        }}
        renderInput={(params) => (
          <TextField fullWidth {...params} label="Deposit To" />
        )}
        {...props}
      />
    </>
  );
};

export default SelectDepositAccount;
